import { render, staticRenderFns } from "./Camera.vue?vue&type=template&id=b0d7ff6e"
import script from "./Camera.vue?vue&type=script&lang=js"
export * from "./Camera.vue?vue&type=script&lang=js"
import style0 from "./Camera.vue?vue&type=style&index=0&id=b0d7ff6e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports